import { Injectable } from '@angular/core';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { ModalService } from '@app/core/modal.service';
import { RejectModalComponent as ModalComponent, ModalResult } from './reject-modal.component';

@Injectable({ providedIn: 'root' })
export class RejectModalService {
  constructor(private modalService: ModalService) {}

  open(options?: NgbModalOptions) {
    return this.modalService.open<ModalResult>(ModalComponent, null, options);
  }
}
